import { EditConfirmation as Confirmation, RouterContext } from '../../gs-component-right-rail';
import React, { useContext } from 'react';

interface Props {
  setClose: (val: boolean) => void;
  resetForm: Function;
  submitForm: Function;
}

export const EditConfirmation: React.FC<Props> = ({ resetForm, setClose, submitForm }) => {
  const { goBack } = useContext(RouterContext);
  return (
    <Confirmation
      onCancel={(): void => {
        goBack();
        setClose(false);
        resetForm();
      }}
      onSave={(): void => {
        goBack();
        submitForm();
      }}
      onContinue={goBack}
    />
  );
};
